module.exports = require("lodash/reduce");


//////////////////
// WEBPACK FOOTER
// external "lodash/reduce"
// module id = 24
// module chunks = 0